import { Pipe, PipeTransform } from '@angular/core';
import { ScreenWidthTypeEnum } from 'app/private/_core/_enums/screen-width-type.enum';

@Pipe({
    name: 'dataTestScreenType',
    standalone: false
})
export class DataTestScreenTypePipe implements PipeTransform {
  transform(value: string, screenType: ScreenWidthTypeEnum): string {
    if (screenType === ScreenWidthTypeEnum.mobile) {
      return value + '_mobile';
    }
    return value;
  }
}
